import ExcelJS from 'exceljs';

const COLUMNAS_DIAS = [
  { key: 'lunes', label: 'LUNES' },
  { key: 'martes', label: 'MARTES' },
  { key: 'miercoles', label: 'MIERCOLES' },
  { key: 'jueves', label: 'JUEVES' },
  { key: 'viernes', label: 'VIERNES' },
  { key: 'sabado', label: 'SABADO' },
  { key: 'domingo', label: 'DOMINGO' },
];

function parseLineasCelda(valor) {
  if (valor == null || String(valor).trim() === '') return [];
  const s = String(valor).trim();
  if (s === 'XX') return [];
  return s
    .split(/\s*\+\s*/)
    .map((x) => x.trim())
    .filter((x) => x.length > 0);
}

function textoCeldaExport(valor, diaIncluido) {
  if (!diaIncluido) return '—';
  const raw = valor ?? '';
  const t = raw.trim();
  if (!t || t === 'XX') return '—';
  const partes = parseLineasCelda(raw);
  if (partes.length === 0) return '—';
  return partes.join(' + ');
}

function sanearNombreArchivo(s) {
  return String(s || 'ciclico')
    .replace(/[/\\?%*:|"<>]/g, '-')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 80);
}

/**
 * Genera y descarga un .xlsx con la grilla de menú cíclico.
 */
export async function exportarCiclicoMenuExcel({
  grupoFilename,
  lineaTitulo,
  periodoTitulo,
  nombreCiclo,
  nombrePlantilla,
  etiquetaSemana,
  periodoRango,
  fechaConfigurado,
  diasSemana,
  grupos,
  matriz,
  nombreTiempo,
  nombreTipo,
}) {
  if (!grupos || grupos.length === 0) {
    throw new Error('No hay datos de plantilla para exportar.');
  }

  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('Cíclico', {
    views: [{ showGridLines: true }],
  });

  let r = 1;
  ws.getCell(r, 1).value = lineaTitulo || 'CÍCLICO — PROGRAMACIÓN DE MENÚ';
  ws.getCell(r, 1).font = { bold: true, size: 12 };
  r += 1;
  if (periodoTitulo) {
    ws.getCell(r, 1).value = periodoTitulo;
    r += 1;
  }
  ws.getCell(r, 1).value = `Cíclico: ${nombreCiclo || '—'}`;
  r += 1;
  if (nombrePlantilla) {
    ws.getRow(r).getCell(1).value = `Plantilla: ${nombrePlantilla}`;
    r += 1;
  }
  ws.getCell(r, 1).value = [
    `Semana: ${etiquetaSemana || '—'}`,
    `Periodo: ${periodoRango || '—'}`,
    fechaConfigurado ? `Configurado: ${fechaConfigurado}` : null,
  ]
    .filter(Boolean)
    .join('   ');
  r += 1;
  r += 1; // línea en blanco

  const firstCol = 1;
  const colOffsetTipo = 2;
  const colFirstDia = 3;
  const lastCol = colFirstDia + COLUMNAS_DIAS.length - 1;
  const headerRow = r;

  ws.getCell(r, 1).value = 'TIEMPO';
  ws.getCell(r, 2).value = 'TIPO / PLATO';
  COLUMNAS_DIAS.forEach((d, j) => {
    ws.getCell(r, colFirstDia + j).value = d.label;
  });
  for (let c = firstCol; c <= lastCol; c++) {
    const cell = ws.getCell(headerRow, c);
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF374151' } };
  }
  r += 1;

  for (const grupo of grupos) {
    const filas = grupo.filas || [];
    const n = filas.length;
    if (n === 0) continue;
    const startR = r;

    filas.forEach((fila, idx) => {
      if (idx === 0) {
        ws.getCell(r, 1).value = nombreTiempo(grupo.tiempoId);
      }
      ws.getCell(r, colOffsetTipo).value = nombreTipo(fila.tipoPlatoId);
      COLUMNAS_DIAS.forEach((d, j) => {
        const key = d.key;
        const activo = diasSemana?.[key];
        const val = matriz?.[key]?.[fila.rowKey];
        ws.getCell(r, colFirstDia + j).value = textoCeldaExport(val, activo);
      });
      r += 1;
    });

    if (n > 1) {
      ws.mergeCells(startR, 1, r - 1, 1);
    }
    ws.getCell(startR, 1).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
  }

  const nota =
    'Días sin menú o no incluidos en plantilla se muestran como "—". ' +
    (diasSemana
      ? `Días con plantilla: ${COLUMNAS_DIAS.filter((d) => diasSemana[d.key])
          .map((d) => d.label)
          .join(', ')}.`
      : '');

  ws.getCell(r, 1).value = nota;
  ws.mergeCells(r, 1, r, lastCol);
  r += 1;

  ws.columns = [
    { width: 16 },
    { width: 22 },
    ...Array(7).fill({ width: 28 }),
  ];

  const freezeRow = headerRow; // título de la tabla
  ws.views = [{ state: 'frozen', ySplit: freezeRow, activeCell: 'A1' }];

  const buffer = await wb.xlsx.writeBuffer();
  const name = `ciclico-${sanearNombreArchivo(grupoFilename)}.xlsx`;
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
